<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.42 58.42">
  <path
    d="M15.79 24.23l2.39 0c0,-6.4 -0.9,-11.03 3.24,-15.34 6.57,-6.83 18.82,-2.21 18.82,7.79l0 7.55c1.61,0 4.16,-0.41 4.16,1.77l0 25c0,0.98 -0.79,1.77 -1.77,1.77l-26.84 0c-0.98,0 -1.77,-0.79 -1.77,-1.77l0 -25c0,-0.98 0.79,-1.77 1.77,-1.77zm5.92 0l14.99 0c0,-5.18 0.83,-9.81 -2.2,-12.84 -4.75,-4.75 -12.79,-1.3 -12.79,5.29l0 7.55zm19.15 3.53l-23.3 0 0 21.47 23.3 0 0 -21.47z"/>
</svg>
